import { render, staticRenderFns } from "./PopupEditSection.vue?vue&type=template&id=1f2f48d6&scoped=true&"
import script from "./PopupEditSection.vue?vue&type=script&lang=js&"
export * from "./PopupEditSection.vue?vue&type=script&lang=js&"
import style0 from "./PopupEditSection.vue?vue&type=style&index=0&id=1f2f48d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2f48d6",
  null
  
)

export default component.exports